import React, { useEffect, useState } from "react";
import callApi from "../../../../../utility/apiCaller";
import "./OffersPage.css";

const OffersPage = ({ pincode: propPincode, name: propName = "Customer" }) => {
  const pincode = propPincode || localStorage.getItem("pincode") || "";
  const name = propName !== "Customer" ? propName : localStorage.getItem("user_name") || "Customer";  // Array of lenders the lead was pushed to
  const lendersToDisplay = [
    { lender_id: "6ac73876ff51f5d7328d7ca1", lender_name: "Muthoot FinCorp", logo: "/assets/bank_img/logo/MuthootFincorpGL.png" },
    { lender_id: "69a2c7ab1f6f4ddfd5577314", lender_name: "IIFL Finance", logo: "/assets/img/image 33.svg" },
    { lender_id: "69ea0b864084a68bdadc40bd", lender_name: "Muthoot Finance", logo: "/assets/bank_img/logo/MuthootFinanceGL.png" },
    { lender_id: "6abb59d6a3ee46254d954755", lender_name: "Oro Money", logo: "/assets/bank_img/logo/OromoneyGL.png" },
    { lender_id: "6aa03dd160f34db15292641e", lender_name: "Rupeek GL", logo: "/assets/bank_img/logo/RupeekGL.png" },
    { lender_id: "6ac37efdf072975a2b2502a2", lender_name: "Capri Global", logo: "/assets/bank_img/logo/CapriLoansGL.png" },
  ];

  const [branches, setBranches] = useState([]);
  const [isLoadingBranches, setIsLoadingBranches] = useState(true);
  const [timer, setTimer] = useState(52);

  // Phone call countdown timer
  useEffect(() => {
    if (timer > 0) {
      const intervalId = setInterval(() => setTimer(t => t - 1), 1000);
      return () => clearInterval(intervalId);
    }
  }, [timer]);

  // Branch fetching logic
  useEffect(() => {
    const fetchAllBranches = async () => {
      try {
        const branchPromises = lendersToDisplay.map(async (lender) => {
          try {
            const response = await callApi(
              "v1/servicable_pincode/branch", 
              "post", 
              { pincode, lender_id: lender.lender_id },
              "loan" 
            );

            console.log(`Response for ${lender.lender_name}:`, response);

            if (response?.data?.found && response?.data?.branch) {
              return {
                ...lender,
                isFound: true,
                branchName: response.data.branch.branch_name,
                address: response.data.branch.branch_address,
                matchedPincode: response.data.branch.matched_pincode
              };
            }
          } catch (err) {
            console.error(`Failed to fetch branch for ${lender.lender_name}`, err);
          }
          
          return {
            ...lender,
            isFound: false,
            branchName: "Branch details unavailable",
            address: "Our lending partner will confirm the nearest branch during your call.",
            matchedPincode: null
          };
        });

        const resolvedBranches = await Promise.all(branchPromises);
        setBranches(resolvedBranches);

      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setIsLoadingBranches(false);
      }
    };

    if (pincode) {
      fetchAllBranches();
    } else {
      const fallbackBranches = lendersToDisplay.map((lender) => ({
        ...lender,
        isFound: false,
        branchName: "Branch details unavailable",
        address: "Our lending partner will confirm the nearest branch during your call.",
        matchedPincode: null
      }));
      setBranches(fallbackBranches);
      setIsLoadingBranches(false); 
    }
  }, [pincode]);

  return (
    <div id="v3-strict-scope" className="offers-page-wrapper">
      
      {/* =========================================
          TOP PROGRESS BAR
          ========================================= */}
      <div className="ty-progress-container">
        <div className="ty-step">
          <div className="ty-step-circle completed">1</div>
          <span className="ty-step-text">Your details</span>
        </div>
        <div className="ty-step-line completed-line"></div>
        <div className="ty-step">
          <div className="ty-step-circle completed">2</div>
          <span className="ty-step-text">Verify mobile</span>
        </div>
        <div className="ty-step-line completed-line"></div>
        <div className="ty-step">
          <div className="ty-step-circle active">3</div>
          <span className="ty-step-text">Request received</span>
        </div>
      </div>

      {/* =========================================
          THANK YOU HEADER
          ========================================= */}
      <div className="ty-header-section">
        <h1>Thank you, {name}</h1>
        <p>Your <strong>Gold Loan</strong> request has been received</p>
      </div>

      {/* =========================================
          MIDDLE GRID: NEXT STEPS & TIMER CARD
          ========================================= */}
      <div className="ty-middle-grid">
        
        {/* Left: Next Steps */}
        <div className="ty-next-steps-card">
          <h3>Next Steps</h3>
          <ul>
            <li>You will receive a call from one of our lending partners shortly.</li>
            <li>They'll guide you to a convenient branch near you.</li>
            <li>Visit with your gold and required KYC documents.</li>
            <li>Once your gold is evaluated and approved, the lender will process your loan.</li>
          </ul>
        </div>

        {/* Right: Phone Timer Card */}
        <div className="ty-timer-card">
          <div className="ty-timer-content">
            <div className="ty-phone-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <div className="ty-timer-text">
              <p>Please pick up the phone. We are calling you in -</p>
              <h2>{timer} seconds</h2>
            </div>
          </div>
          <button className="ty-back-btn" onClick={() => window.location.reload()}>
            Back to Calculator
          </button>
        </div>
      </div>

      {/* =========================================
          LENDER LOGOS STRIP
          ========================================= */}
      <div className="ty-logos-strip">
        {lendersToDisplay.map((lender, index) => (
          <img key={index} src={lender.logo} alt={lender.lender_name} />
        ))}
      </div>

      {/* =========================================
          BOTTOM SECTION: EXPLORE NEARBY
          ========================================= */}
      <div className="ty-nearby-container">
        <div className="ty-nearby-header">
          <div>
            <p className="ty-small-caps">EXPLORE NEARBY</p>
            <h2 className="ty-nearby-title">Lender branches near {pincode ? pincode : "you"}</h2>
          </div>
          <p className="ty-nearby-disclaimer">
            Indicative locations from available lenders. Please confirm<br />
            the exact branch and availability during the lender call.
          </p>
        </div>

        {isLoadingBranches ? (
          <div className="ty-loading-branches">
            <p>Locating nearest branches...</p>
          </div>
        ) : (
          <div className="ty-branches-grid">
            {branches.map((branch, index) => (
              <div key={index} className="ty-branch-card">
                <div className="ty-branch-logo-wrapper">
                  <img src={branch.logo} alt={branch.lender_name} className="ty-branch-logo" />
                </div>
                <p className="ty-branch-label">NEARBY BRANCH</p>
                <h3 className="ty-branch-name">{branch.branchName}</h3>
                <p className="ty-branch-address">{branch.address}</p>
              </div>
            ))}
          </div>
        )}
      </div>

    </div>
  );
};

export default OffersPage;